import React from 'react'

interface Cart{
  token:string
  productId:number | string
  price:string
}
function UseAdd({token,productId,price}:Cart) {

   const addToCart =async ()=>{
    try{
      const response = await fetch('https://djangodrf.arifsultani291.digital/products/cart/',{
        method:'POST',
        headers:{'Content-Type':'application/json'},
        body:JSON.stringify({
          token:token,
          product:productId,
          price:price
        })
       })
       if(response.ok){
        const jsonData = await response.json()
        console.log(jsonData)
       }else{
        const jsonData = await response.json()
        console.log(jsonData)
       }

    }catch(error:any){
      console.log('thisis',error.message)

    }
   
   }

   


  return{addToCart}
}

export default UseAdd
